import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '@/api/client';
import { ErrorNote, SubmitButton } from '@/components/ui';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setPending(true);
    setError(null);
    try {
      await apiFetch('/api/auth/forgot-password', { method: 'POST', body: { email }, anonymous: true });
      setSent(true);
    } catch (err) {
      setError(err);
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-sm">
        {sent ? (
          <div className="card space-y-3 p-6">
            <h1 className="text-lg font-semibold">Check your inbox</h1>
            <p className="text-sm text-slate-600">
              If <span className="font-medium">{email}</span> belongs to an account, a reset link is on its way. It expires in one hour.
            </p>
            <Link to="/login" className="btn-secondary w-full">Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="card space-y-4 p-6">
            <div>
              <h1 className="text-lg font-semibold">Reset your password</h1>
              <p className="mt-0.5 text-sm text-slate-500">We'll email you a link to set a new one.</p>
            </div>
            <ErrorNote error={error} />
            <div>
              <label className="label" htmlFor="email">Email address</label>
              <input id="email" type="email" className="input" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <SubmitButton pending={pending} className="btn-primary w-full">Send reset link</SubmitButton>
            <p className="text-center text-sm">
              <Link to="/login" className="text-brand-700 hover:underline">Back to sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
